<template>
  <div class="student-track">
    <div class="student-head">
      <img src="@/views/pt/images/class_bg.png" alt="" />
      <div class="student-head_title">学生掌握情况</div>
    </div>
    <div class="knowledge-subject">
      <span class="subject-type">学生学过的科目:</span>
          <span v-for="(item,i) in subjectList" :key="i"
          :class="[{'active':item.id===subjectId},'subject-item']"
          @click="subjectClick(item)"
          >{{item.name}}
          </span>
    </div>
    <StudentDetail/>
  </div>
</template>

<script>
import StudentDetail from './student-detail.vue';

export default {
  components: { StudentDetail },
  data() {
    return {
      // 科目列表
      subjectList: [
        { name: '数学', id: 1 },
        { name: '语文', id: 2 },
        { name: '物理', id: 3 },
      ],
      subjectId: 1,
      // 学习内容列表
      contentList: [
        { name: '一年级上册', id: 1 },
        { name: '一年级下册', id: 2 },
        { name: '二年级上册', id: 3 },
        { name: '三年级上册', id: 4 },
        { name: '五年级上册', id: 5 },
      ],
      contentId: 0,
    };
  },
  methods: {
    subjectClick(item) {
      this.subjectId = item.id;
    },
    contentClick(id) {
      this.contentId = id;
    },
  },
};
</script>

<style lang="scss" scoped>
.student-track{
  padding: 41px 24px 30px 24px;
  .student-head{
    position: relative;
     width: 100%;

    &_title{
      position: absolute;
      font-size: 17px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.8);
      top: 5px;
      left: 13px;
    }
  }
  .knowledge-subject{
      height: 70px;
      width: 100%;
      line-height: 70px;
      .subject-type{
        font-size: 16px;
        color: #000000;
        margin-right:30px ;
      }
      .subject-item:last-child{
        font-size: 14px;
        color: #303133;
      }
      .subject-item:not(:last-child){
        font-size: 14px;
        color: #303133;
        display: inline-block;
        margin-right:52px ;
        position: relative;
        &::before{
          content: '';
          width: 4px;
          height: 4px;
          background: #C0C4CC;
          border-radius: 50%;
          left: 50px;
          top: 33px;
          position: absolute;
        }
      }
      .active{
          color: #1989FA !important;
      }
    }
    .knowledge-content{
      .content-type{
        font-size: 16px;
        color: #000000;
        margin-right:30px ;
      }
       .content-all{
        font-size: 14px;
        color: #303133;
        display: inline-block;
        margin-right:52px ;
        position: relative;
        &::before{
          content: '';
          width: 4px;
          height: 4px;
          background: #C0C4CC;
          border-radius: 50%;
          left: 50px;
          top: 8px;
          position: absolute;
        }
      }
      .content-item:last-child{
        font-size: 14px;
        color: #303133;
      }
      .content-item:not(:last-child){
        font-size: 14px;
        color: #303133;
        display: inline-block;
        margin-right:52px ;
        position: relative;
        &::before{
          content: '';
          width: 4px;
          height: 4px;
          background: #C0C4CC;
          border-radius: 50%;
          left: 95px;
          top: 8px;
          position: absolute;
        }
      }
      .active{
          color: #1989FA !important;
      }
    }
}
</style>
